import {
  DashboardViewContainer,
  DashboardViewContent,
  DashboardViewHeader,
  DashboardViewTitle,
} from '@/common/ui/DashboardViewStyles';
import { Badge } from '@shadcn/components/badge';
import dayjs from 'dayjs';
import changelogItems, {
  ChangelogEntry,
  tagLabels,
  tagStyles,
} from './changelogItems';

function EntryCard({ entry }: { entry: ChangelogEntry }) {
  return (
    <div className="border-b last:border-b-0 py-6 px-1">
      <div className="flex items-center gap-3 mb-2">
        <span className="text-sm text-muted-foreground">
          {dayjs(entry.date).format('DD MMM YYYY')}
        </span>
        {entry.tags?.map((tag) => (
          <Badge
            key={tag}
            variant="outline"
            className={tagStyles[tag] || ''}
          >
            {tagLabels[tag] || tag}
          </Badge>
        ))}
      </div>
      <h2 className="text-lg font-semibold mb-1">{entry.title}</h2>
      <p className="text-sm text-muted-foreground">{entry.content}</p>
      {entry.image && (
        <img
          src={entry.image.src}
          alt={entry.image.alt}
          className="mt-3 rounded-md max-h-[300px] object-contain w-fit"
        />
      )}
      {entry.video && (
        <video
          src={entry.video.src}
          controls
          className="mt-3 rounded-md max-h-[300px] w-full"
        />
      )}
    </div>
  );
}

export default function ChangelogView() {
  return (
    <DashboardViewContainer>
      <DashboardViewHeader>
        <DashboardViewTitle>Changelog</DashboardViewTitle>
      </DashboardViewHeader>

      <DashboardViewContent>
        <div className="max-w-2xl mx-auto px-4 py-4">
          {changelogItems.map((entry) => (
            <EntryCard key={entry.id} entry={entry} />
          ))}
        </div>
      </DashboardViewContent>
    </DashboardViewContainer>
  );
}
